// Compliance frameworks super admin can switch on per organisation.
// `value` is the name spark-authentication stores in the licence (feature_json.frameworks).
// Keep this list in step with ASSIGNABLE_FRAMEWORKS and DEFAULT_FRAMEWORKS in
// spark-authentication's app/constants.py.
export const ASSIGNABLE_FRAMEWORKS = [
  { value: "CIS", label: "CIS Controls", onByDefault: true },
  { value: "NIST", label: "NIST", onByDefault: true },
  { value: "PCI DSS", label: "PCI DSS", onByDefault: true },
  { value: "SPARK", label: "SPARK Framework", onByDefault: true },
  { value: "DoT", label: "DoT", onByDefault: false },
];

/** What an organisation gets until super admin chooses: every framework except DoT. */
export const DEFAULT_FRAMEWORKS = ASSIGNABLE_FRAMEWORKS.filter(
  (framework) => framework.onByDefault
).map((framework) => framework.value);

const KNOWN = ASSIGNABLE_FRAMEWORKS.map((framework) => framework.value);

/** The selected list with `value` switched on or off, in the order of the list above. */
export const setFramework = (
  selected: string[],
  value: string,
  on: boolean
): string[] => {
  const next = new Set(selected);
  if (on) next.add(value);
  else next.delete(value);
  return [
    ...KNOWN.filter((name) => next.has(name)),
    ...[...next].filter((name) => !KNOWN.includes(name)),
  ];
};

/** True when both lists hold the same frameworks, in any order. */
export const sameFrameworks = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((name) => b.includes(name));

/** Display names for stored framework names, comma separated. */
export const frameworkLabels = (names: string[]): string =>
  names
    .map(
      (name) =>
        ASSIGNABLE_FRAMEWORKS.find((framework) => framework.value === name)
          ?.label ?? name
    )
    .join(", ");
